module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-UploadInformationModelImages-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('informationModelImagesUploadDialogTitle')))]), _vm._v(" "), _c('el-form', {
    ref: "data",
    attrs: {
      "model": _vm.data,
      "id": "uploadform",
      "enctype": "multipart/form-data",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, _vm._l((_vm.fieldsData), function(field, key) {
    return _c('el-form-item', {
      key: key,
      attrs: {
        "data-qa": ("Dialog-UploadInformationModelImagesUpload-" + key),
        "label-width": _vm.labelWidth,
        "label": field.label
      }
    }, [_c('div', {
      staticClass: "image-block"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (field.currentImgSrc),
        expression: "field.currentImgSrc"
      }],
      attrs: {
        "src": field.currentImgSrc,
        "height": "34"
      },
      on: {
        "error": function($event) {
          _vm.whenImageNotFound(key)
        }
      }
    }), _vm._v(" "), _c('input', _vm._b({
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (field.validate),
        expression: "field.validate"
      }],
      staticClass: "input-file",
      attrs: {
        "id": field.name,
        "name": field.name,
        "accept": "image/png, image/gif, image/jpg, image/jpeg",
        "data-qa": ("Dialog-UploadInformationModelImages" + key + "-UploadImage"),
        "type": "file"
      },
      on: {
        "change": function($event) {
          _vm.filesChange(key, $event.target.name, $event.target.files)
        }
      }
    }, 'input', field.model, false)), _vm._v(" "), _c('label', {
      staticClass: "el-button el-button--default",
      attrs: {
        "for": field.name
      }
    }, [_vm._v(_vm._s(_vm.$t('informationModelImagesUploadButtonUploadImageText')))]), _vm._v(" "), (field.isLocal || !field.uri) ? _c('div', {
      staticClass: "selected-file-name"
    }, [_vm._v(_vm._s(field.selectedFileName))]) : _vm._e(), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (field.uri && !field.isLocal),
        expression: "field.uri && !field.isLocal"
      }],
      attrs: {
        "data-qa": ("Dialog-UploadInformationModelImages" + key + "-RemoveImage")
      },
      on: {
        "click": function($event) {
          _vm.removeImage(key, field.name)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('informationModelImagesUploadButtonRemoveImageText')) + "\n        ")])], 1), _vm._v(" "), (_vm.errors.has(field.name)) ? _c('div', {
      staticClass: "help is-danger"
    }, [_vm._v("\n        " + _vm._s(_vm.errors.first(field.name)) + "\n      ")]) : _vm._e(), _vm._v(" "), (!field.isValidImageSize) ? _c('div', {
      staticClass: "help is-warning"
    }, [_vm._v("\n        " + _vm._s(field.imageErrorMsg) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "column-describe",
      attrs: {
        "data-qa": ("Content-UploadInformationModelImages" + key + "-Description")
      }
    }, [(field.uri) ? _c('p', [_vm._v(_vm._s(field.uri))]) : _vm._e(), _vm._v(" "), _c('i', [_vm._v(_vm._s(field.description))])])])
  })), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    staticClass: "btn-close",
    attrs: {
      "data-qa": "Dialog-UploadInformationModelImages-Button-Cancel",
      "type": "text"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('informationModelImagesUploadDialogButtonCloseText')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Dialog-UploadInformationModelImages-Button-Save",
      "type": "warning"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('informationModelImagesUploadDialogButtonSaveText')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-161ea40a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InformationModelImagesUpload/InformationModelImagesUpload.vue
// module id = 954
// module chunks = 3